import React from 'react';

import Button from 'rebook/apps/base/components/Button';

import styles from './style.scss';


const PaymentsGiftSubscription = ({ onSubscriptionTypeChange }) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <div className="title-2">Подарите подписку друзьям и близким</div>
      <p>Подарочный код на любой срок</p>
      <div className={styles.button}>
        <Button
          handleClick={() => {
            ga('send', 'event', 'Payments', 'Gift', 'Premium');
            onSubscriptionTypeChange('pro');
          }}
          extraClassName="jest-payments-gift-premium-btn"
          theme="secondary"
          size="small">
          Купить Премиум
        </Button>
      </div>
      <div className={styles.button}>
        <Button
          handleClick={() => {
            ga('send', 'event', 'Payments', 'Gift', 'Standard');
            onSubscriptionTypeChange('standard');
          }}
          extraClassName="jest-payments-gift-standard-btn"
          theme="secondary"
          size="small">
          Купить Стандарт
        </Button>
      </div>
    </div>
  </div>
);

export default PaymentsGiftSubscription;
